export default "__VITE_ASSET__8a43673d__"